import type { TriggerConfig } from '@/types/custom-playbooks';

export const PLAY_ID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function object(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

/** Mirrors the closed, draft-compatible API config. Targets require server scope checks. */
export function handOffConfigError(value: unknown): string | null {
  if (
    !object(value) ||
    Object.keys(value).some(
      (key) => !['playbookId', 'playName'].includes(key)
    ) ||
    typeof value.playbookId !== 'string' ||
    !PLAY_ID.test(value.playbookId)
  )
    return 'Pick a play of this agent';
  if (
    value.playName !== undefined &&
    value.playName !== null &&
    (typeof value.playName !== 'string' ||
      !value.playName.trim() ||
      Array.from(value.playName).length > 120)
  )
    return 'Use a play name of up to 120 characters';
  return null;
}

export function handOffTriggerReady(value: Partial<TriggerConfig>): boolean {
  return (
    value.source === 'play' &&
    value.kind === 'play_handoff' &&
    object(value.play) &&
    Object.keys(value.play).length === 1 &&
    ['person', 'company'].includes(value.play.recordKind)
  );
}
